if (!customElements.get('video-autoplay')) {
  customElements.define(
    'video-autoplay',
    class VideoAutoplay extends HTMLElement {
      constructor() {
        super()
        this.video = this.querySelector('video')
        this.button = this.querySelector('button')
        this.motionSafe = true
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
        if (mediaQuery.matches) {
          this.motionSafe = false
        }
        this.interacted = false
        this.init()
      }
      init() {
        this.button.addEventListener('click', () => {
          this.video.paused ? this.video.play() : this.video.pause()
          this.interacted = true
        })
        this.video.addEventListener('play', () => {
          this.button.setAttribute('aria-pressed', true)
        })
        this.video.addEventListener('pause', () => {
          this.button.setAttribute('aria-pressed', false)
        })

        if (!this.motionSafe) {
          return
        }
        let videoCallback = (entries, observer) => {
          entries.forEach((entry) => {
            if (this.interacted) {
              return
            }
            if (entry.isIntersecting) {
              this.video.play()
              this.button.setAttribute('aria-pressed', true)
            } else {
              this.video.pause()
              this.button.setAttribute('aria-pressed', false)
            }
          })
        }
        let options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
        const videoObserver = new IntersectionObserver(videoCallback, options)
        videoObserver.observe(this)
      }
    }
  )
}
